module.exports = __webpack_public_path__ + "img/hammam_COR.137b9d4b.jpg";